// extracted by mini-css-extract-plugin
export default {"button":"style_button__wNouV","cont":"style_cont__nZK6v"};